import React from "react";
import Dashboard from "./Dashboard";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { formatedDateTimeIntoIst } from "src/utils/formUtils/dateTimeFormate";
import moment from "moment";
import {
  useGetDashboardOrderQuery,
  useGetRazorpayOrdersSummaryQuery,
} from "src/services/DashboardService";

const DashboardWrapper = () => {
  const { dateFilter } = useSelector((state: RootState) => state.dashboard);

  const startDate = dateFilter.start_date
    ? formatedDateTimeIntoIst(dateFilter.start_date, "YYYY-MM-DD")
    : "";
  const endDate = dateFilter.end_date
    ? moment(dateFilter.end_date).format("YYYY-MM-DD")
    : dateFilter.start_date
    ? moment().format("YYYY-MM-DD")
    : "";

  const { data: videoData, isLoading: videoLoading } =
    useGetDashboardOrderQuery({ dateFilter: { startDate, endDate } });

  const { data: razorpayData, isLoading: razorpayLoading } =
    useGetRazorpayOrdersSummaryQuery({ startDate, endDate });

  const dashboardData = {
    videoLoading: videoLoading,
    videoLectureOrders: {
      success: videoData?.data?.successfulOrder || 0,
      pending: videoData?.data?.pendingOrder || 0,
      failed: videoData?.data?.failedOrder || 0,
      cancelled: videoData?.data?.cancelledOrder || 0,
    },
    razorpayLoading: razorpayLoading,
    razorpay: {
      success: razorpayData?.data?.successfulOrder || 0,
      failed: razorpayData?.data?.failedOrder || 0,
      pending: razorpayData?.data?.pendingOrder || 0,
      totalOrder: razorpayData?.data?.totalOrder || 0,
    },
  };

  return (
    <SideNavLayout>
      <Dashboard data={dashboardData} />
    </SideNavLayout>
  );
};

export default DashboardWrapper;
